import React, { useState,useEffect,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './carddaydisplay.css'




import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
    Input,
    Col,
    Row,
  } from "reactstrap";

import 'rc-slider/assets/index.css';



const CooperTest = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  const dispatch = useDispatch()

  const [distance,setDistance] = useState(0)
  const [vo2max,setvo2max] = useState(0)
  const [age,setAge] = useState(25)
  const [modal, setModal] = useState(false);
  const [sex,setSex] = useState('male')
  const [feedback,setFeedback] = useState('--')
  
  
    
    const cooperTest = () =>{
        if (distance<1000){
            alert("Distance invalid")
        }
        else{
            const vomax=(distance-504.9)/44.73;
            setvo2max(vomax.toFixed(0))
            feedBackCalc()
        }
        
    }
    
  const feedBackCalc = () =>{
     if (sex === "male"){
        if (age>=15 && age<=20){
            if (distance>3000){
                setFeedback("Excellent")
                
            }
            else if (distance>2700){
               setFeedback("Above average")
               
           }
           else if (distance>2500){
               setFeedback("Average")
               
           }
           else if (distance>2300){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>20 && age<=30){
            if (distance>2800){
                setFeedback("Excellent")
                
            }
            else if (distance>2400){
               setFeedback("Above average")
               
           }
           else if (distance>2200){
               setFeedback("Average")
               
           }
           else if (distance>1600){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>30 && age<=40){
            if (distance>2700){
                setFeedback("Excellent")
                
            }
            else if (distance>2300){
               setFeedback("Above average")
               
           }
           else if (distance>2100){
               setFeedback("Average")
               
           }
           else if (distance>1500){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>40 && age<=50){
            if (distance>2500){
                setFeedback("Excellent")
                
            }
            else if (distance>2100){
               setFeedback("Above average")
               
           }
           else if (distance>1700){
               setFeedback("Average")
               
           }
           else if (distance>1400){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>50 ){
            if (distance>2400){
                setFeedback("Excellent")
                
            }
            else if (distance>2000){
               setFeedback("Above average")
               
           }
           else if (distance>1600){
               setFeedback("Average")
               
           }
           else if (distance>1300){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
     }
     else{
        if (age>=15 && age<=20){
            if (distance>2100){
                setFeedback("Excellent")
                
            }
            else if (distance>2000){
               setFeedback("Above average")
               
           }
           else if (distance>1700){
               setFeedback("Average")
               
           }
           else if (distance>1600){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>20 && age<=30){
            if (distance>2700){
                setFeedback("Excellent")
                
            }
            else if (distance>2200){
               setFeedback("Above average")
               
           }
           else if (distance>1800){
               setFeedback("Average")
               
           }
           else if (distance>1500){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>30 && age<=40){
            if (distance>2500){
                setFeedback("Excellent")
                
            }
            else if (distance>2000){
               setFeedback("Above average")
               
           }
           else if (distance>1700){
               setFeedback("Average")
               
           }
           else if (distance>1400){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>40 && age<=50){
            if (distance>2300){
                setFeedback("Excellent")
                
            }
            else if (distance>1900){
               setFeedback("Above average")
               
           }
           else if (distance>1500){
               setFeedback("Average")
               
           }
           else if (distance>1200){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
        if (age>50 ){
            if (distance>2200){
                setFeedback("Excellent")
                
            }
            else if (distance>1700){
               setFeedback("Above average")
               
           }
           else if (distance>1400){
               setFeedback("Average")
               
           }
           else if (distance>1100){
               setFeedback("Below Average")
               
           }
           else{
               setFeedback("Poor")
           }
        }
     }
     
  }
 
  
  const toggle = () => setModal(!modal);
  

  return (
    <div>
      <Button className='btn-success' onClick={toggle}>Cooper Test</Button>
      <Modal isOpen={modal} toggle={toggle} className='' style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Cooper Test</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

                <div className="cardDisplay">
              
                
              
                <label style={{color:'rgb(200,200,200)'}}>Distance in meters covered in 12 minutes</label>
                <Input style={{color:'rgb(100,100,255)'}} type='number' value={distance} onChange={e =>setDistance(e.target.value)}></Input>
                <Input type="select" value={sex} onChange={(e)=>setSex(e.target.value)}style={{marginTop:'10px',backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                  <option value='male'>Male</option> 
                  <option value ='female'>Female</option>
                  
                  
                                    
                </Input>
             
              
              <div className="title"></div>
              
              <div className="actions">
              <div className="follow-info">
                
              <h2>
                  <a href="#">
                  <span className="text-white" style={{fontSize:'20px'}}><Input style={{color:'rgb(100,100,255)'}} type='number' value={age} onChange={e =>setAge(e.target.value)}></Input></span>
                  
                     
                     
                 
                     
                     
                     <small>Age</small>
                     
                     
                     
                     
                     
                  </a>
              </h2>     
              <h2>
                  <a href="#">
                     
                     <span className="text-white" style={{fontSize:'30px'}}>{vo2max}</span>
                     
                     
                 
                     
                     
                     <small>VO2max</small>
                     
                     
                     
                     
                     
                  </a>
              </h2>
              <h2>
                  <a href="#">
                     
                     <span className="text-white" style={{fontSize:'20px'}}>{feedback}</span>
                     
                     
                 
                     
                     
                     <small>Feedback</small>
                     
                     
                     
                     
                     
                  </a>
              </h2>
           
                  
                
                    
                    
                    
                
               
                
              </div>
              
              <div className="follow-info" style={{alignItems:'center',justifyContent:'center'}}>
              
              </div>
                <div className="follow-btn">
                <Row>
                    
                    <Col sm={12} lg={12} md={12}>
                    <button className="text-white" onClick={cooperTest}>Calculate</button>
                    </Col>
                    
                </Row>
                
                
                  
                </div>
              </div>
              
              
              <div className="desc"></div>
            </div>
            

  
        
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
        
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default CooperTest;